import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormSelect, FormPanel } from '@eas/common-web';
import { usePrograms } from '../operator-api';

export function SpecificTargetsFields() {
  const intl = useIntl();
  const programs = usePrograms();

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="KS_O_SPECIFIC_TARGETS_FIELD_PANEL_TITLE"
          defaultMessage="Specifický cíl"
        />
      }
    >
      <FormSelect
        name="parent"
        required
        label={
            <FormattedMessage
            id="KS_O_SPECIFIC_TARGETS_FIELD_LABEL_PARENT"
            defaultMessage="Program"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_SPECIFIC_TARGETS_FIELD_HELP_PARENT',
          defaultMessage: ' ',
        })}
        source={programs}
        tooltipMapper={(o) => o.name}
      />
    </FormPanel>
  );
}
